
import React from 'react';
import { Chart } from 'react-google-charts';


function OrganicNonOrganic() {
    const data = [
        ["Year", "Organic", "Non Organic"],
        ["500", 6.5, 15.0],
        ["1000", 11.2, 12.4],
        ["1500", 10.1, 13.2],
        ["2000", 19.7, 5.0],
        ["2500", 17.4, 5.0],
    ];
    
    
    const options = {
        title: 'Organic Vs Non-organic', 
        curveType: "function",
        legend: { position: "bottom" },       
        series: {
            0: { color: '#e2431e' },
            1: { color: '#6f9654' },
        },
    };
    

    return (
        <div style={{ width: '100%' }}>
            <Chart
                chartType="LineChart"
                width="100%"
                height="400px"
                data={data}
                options={options}
            />        
        </div>
    );
}

export default OrganicNonOrganic;